(function($, B) {


    'use strict';


    $.extend(true, B, {
        field:{
            read:function(element, options){
                options = options || {};
                var $el = $(element),
                    field = B.field.get(element),
                    value,
                    _read = {
                        checkbox: function(){
                            var v = field.$field.val();
                            if (field.$field.length > 1) {
                                var $checked = field.$field.filter(':checked');
                                if($checked.length == field.$field.length && options.hasOwnProperty('allValue')){
                                    value = options.allValue;
                                }else{
                                    value = [];
                                    $checked.each(function() {
                                        value.push($(this).val());
                                    });
                                }
                            } else {
                                value = field.$field.is(':checked') ? field.$field.val() || 1 : 0;
                            }                   
                        },
                        radio:function(){
                            value = field.$field.filter(':checked').val();
                        },
                        selectOne:function(){
                            value = field.$field.find('option:selected').val();   
                        },
                        generic: function(){
                            value = field.$field.val();
                        }
                    };




                if(B.isFunction(_read[field.fn])){
                    _read[field.fn]();
                }else{
                    _read.generic();
                }
                return value !== undefined ? value : null;
            },
            getType:function(element){
                var $el = $(element),
                    type = $el.data('field-type') || $el.prop('type') || $el.prop('tagName');
                return type === undefined ? '' : type.toLowerCase();
            },
            get:function(element){
                var $el=$(element),
                    field = {
                        $field : $el,
                        fieldType : $el.data('fieldType'),
                        fn : null
                    };
                if(!field.fieldType){
                    if(!$el.is(':input')){
                        field.$field = $el.find('input');
                    }
                    field.fieldType = B.field.getType(field.$field);
                }
                field.fn = B.str.camelCase(field.fieldType);       
                return field;    
            }

        },
        form: {
            valuesToObject:function(values){
                var out = {};
                for(var k in values){
                    if(k.indexOf('[') > 0){
                        var r = /\[[^\].]*]/g,
                            keys = [k.substr(0, k.indexOf('['))],
                            match;
                        while(match = r.exec(k)){
                            keys.push(match[0].slice(1, match[0].length - 1));
                        }
                        B.obj.deepValueSet(keys, out, values[k]);
                    }else{
                        out[k] = values[k];
                    }
                }
                return out;
            }
        },
        filter: {
            read: function(element){
                var $el = $(element);
                var filters = {};
                $el.find('[data-filter-field]').each(function(){
                    var o = $(this).data(),
                        value = B.field.read(this, { allValue: null });
                    if(value !== null && value !== ''){
                        switch(o.fieldType){
                            case 'like':
                                filters[$(this).data('filterField')] = '%' + value + '%';  
                            break;
                            default:
                                filters[$(this).data('filterField')] = (o.fieldType) 
                                    ? { type: o.fieldType, value: value }
                                    : value;
    
                        }
                    }
                });
                filters = B.form.valuesToObject(filters);
                return filters;
          
            }
        }
    });

    B.web.onReady['filter'] = function(){
        $('[data-widget="filter"]').each(function(){
            var $filter = $(this),
                o = $filter.data('widgetOptions'),
                $fields = $filter.find('[data-filter-field]'),
                $submit = $filter.find('[data-filter-button="submit"'),
                values,
                _read=function(){
                    values = B.filter.read($filter);
                    $filter.trigger('changed', values);
                };

                if(o.manual && $submit.length > 0){
                    $submit.on('click', _read);
                }

                $fields.on('change', function(e){    
                    stopTrigger(e);
                    if(!o.manual){
                        _read();
                    }
                });
        });
    };
    $.fn.getField=function(){
        return B.field.get(this);
    };

    $.fn.getFieldType = function() {
        return B.field.getType(this);
    };

    $.fn.readField = function(options){
        return B.field.read(this, options);
    };

    $.fn.readFilter = function(options){
        return B.filter.read(this, options);
    };

})(jQuery, Bajt);